const serviceLimitComponent = {
    templateUrl: '/modules/service-limit/service-limit.html',
    controller: 'ServiceLimitController',
};

angular
    .module('service-limit.module', [
        'ui.router',
    ])
    .component('serviceLimitComponent', serviceLimitComponent)
    .config(function ($stateProvider) {
        $stateProvider.state('service-limit', {
            url: '/service-limit',
            component: 'serviceLimitComponent',
        });
    });
